import Bullets from "../decorations/Bullets";
import Stripes from "../decorations/Stripes";
import LiquidEther from "../decorations/LiquidEther";

const Decorations = {
  Bullets,
  Stripes,
  LiquidEther,
};

export default Decorations;
